import Social from "../Social/Social";
import Policy from "../Policy/Policy";
import {isMobile } from 'react-device-detect';

function Footer({policyId, handleDebugClick}) {
  return (
  <footer id="footer" className="footer">
    <div className="columns content">
      <div className="column is-5 mb-1">

      {policyId && <Policy policyId={policyId} />}

      <p className="responsible-message mt-3">Our teams urge everyone to be responsible. Please do not spend money you need for bills or taking care of loved ones. Please do not take out loans or borrow money to mint<span onClick={handleDebugClick}>.</span></p>
      </div>
      <div className={`column is-4 is-offset-${policyId ? "3" : "8"}`}>
        <Social 
          justify={isMobile ? "start" : "end"}
          size="30px"
          iconMargin="0 10px" />
        <p id="publisher-line" className={`has-text-${isMobile ? "left": "right"}`}>
          Made with <i className="fa fa-heart fa-sm" style={{ color: 'red' }} /> by <a href="http://canucks-publishing.com/">Canucks Publishing</a>
        </p>
      </div>
    </div>
  </footer>);
}
export default Footer;